export default __webpack_public_path__ + "static/media/inactive_edit_icon.e57dbe21.svg";